// extracted by mini-css-extract-plugin
export var errorIcon = "_qn-1";
export var nameLogo = "_qn-0";